export default __webpack_public_path__ + "static/media/Flag_of_Bahrain.6ca2fe65.png";